import { Theme } from "@material-ui/core/styles";

const styles = (theme: Theme) =>
  ({
    tableRowHeader: {
      "& td, & th": {
        borderBottom: "none",
        padding: "0 16px",
        background: "white",
        "&:last-child": {
          width: 3,
        },
      },
      "& th": {
        "& > div": {
          display: "flex",
          alignItems: "center",
        },
      },
    },
    headCellContainer: {
      width: "fit-content",
      maxWidth: "80%",
    },
    headLabel: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      maxWidth: 154,
    },
    iconSort: {
      opacity: 0.2,
    },
    iconActive: {
      "& svg": { color: theme.palette.secondary.dark + " !important" },
    },
    checkboxSelect: {
      padding: 0,
    },
  } as any);

export default styles;
